module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 33);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/regenerator");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-utils");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/helper");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/variable");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("@tencent/iwan-login");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/tips");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export enablePhoneLogin */
/* unused harmony export disablePhoneLogin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isHidePhoneLogin; });
if (typeof window.isHidePhoneLoginValue === 'undefined') {
  window.isHidePhoneLoginValue = true;
}

/**
 * 允许手机号登录选项
 */
var enablePhoneLogin = function enablePhoneLogin() {
  window.isHidePhoneLoginValue = false;
};

/**
 * 禁止手机号登录选项
 */
var disablePhoneLogin = function disablePhoneLogin() {
  window.isHidePhoneLoginValue = true;
};
var isHidePhoneLogin = function isHidePhoneLogin() {
  return window.isHidePhoneLoginValue;
};

/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/button");

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/dialog");

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleLoginType; });
/* harmony import */ var _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tencent_iwan_login__WEBPACK_IMPORTED_MODULE_0__);


// 判断登录账户登录态类型, 并返回登录态类型
var handleLoginType = function handleLoginType(type) {
  var loginType = '';
  if (!type) {
    return loginType;
  }
  if ([_tencent_iwan_login__WEBPACK_IMPORTED_MODULE_0__["LoginType"].qq, 'qq'].includes(type)) {
    loginType = 'qq';
  } else if ([_tencent_iwan_login__WEBPACK_IMPORTED_MODULE_0__["LoginType"].wx, 'wx', 'weixin'].includes(type)) {
    loginType = 'wx';
  }
  ;
  return loginType;
};

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

module.exports = require("js-cookie");

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "login", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logout", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLogin", function() { return isLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkLogin", function() { return checkLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLogin", function() { return changeLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userCookie", function() { return userCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userKey", function() { return userKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCommonParams", function() { return getCommonParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loginThenReload", function() { return loginThenReload; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3);
/* harmony import */ var _tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1);
/* harmony import */ var _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony import */ var _tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _tencent_txv_athena_comps_common_dialog__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16);
/* harmony import */ var _tencent_txv_athena_comps_common_dialog__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_athena_comps_common_dialog__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _tencent_txv_athena_comps_common_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13);
/* harmony import */ var _tencent_txv_athena_comps_common_button__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_athena_comps_common_button__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5);
/* harmony import */ var _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_tencent_iwan_login__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _tencent_txv_athena_comps_common_tips__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6);
/* harmony import */ var _tencent_txv_athena_comps_common_tips__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_athena_comps_common_tips__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_12__);


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }











var clearTenvideoCookies = function clearTenvideoCookies() {
  try {
    var cookielist = ['main_login', 'appid', 'openid', 'access_token', 'refresh_token', 'vqq_access_token', 'vqq_appid', 'vqq_next_refresh_time', 'vqq_openid', 'vqq_refresh_token', 'vqq_vuserid', 'vqq_vusession', 'vuserid', 'vusession', 'next_refresh_time'];
    cookielist.forEach(function (item) {
      js_cookie__WEBPACK_IMPORTED_MODULE_12___default.a.remove(item, {
        domain: 'iwan.qq.com'
      });
    });
    if (!!document) document.domain = 'qq.com';
    cookielist.forEach(function (item) {
      js_cookie__WEBPACK_IMPORTED_MODULE_12___default.a.remove(item, {
        domain: 'qq.com'
      });
    });
  } catch (err) {
    console.error(err);
  }
  ;
};

/**
 * 各个场景登录与注销
 */
var login = /*#__PURE__*/function () {
  var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee() {
    var _len,
      args,
      _key,
      _paramsHandle,
      succCallback,
      failCallback,
      res,
      _ref2,
      errCode,
      _args = arguments;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["isGameMsdk"])()) {
            _context.next = 4;
            break;
          }
          _tencent_txv_athena_comps_common_tips__WEBPACK_IMPORTED_MODULE_9___default()({
            text: '当前登录态已过期，即将重新加载页面，请稍后重试～'
          });
          setTimeout(function () {
            location.reload();
          }, 2000);
          return _context.abrupt("return", _tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_5__["LOGIN_STATUS"].cancel);
        case 4:
          clearTenvideoCookies(); // 在重新登陆前清理前端cookie，彻底解决脏登录态问题

          _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_8___default.a.isHidePhoneLogin = Object(_config__WEBPACK_IMPORTED_MODULE_11__[/* isHidePhoneLogin */ "a"])();
          for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = _args[_key];
          }
          _paramsHandle = Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["paramsHandle"])(args), succCallback = _paramsHandle.succCallback, failCallback = _paramsHandle.failCallback;
          _context.next = 10;
          return _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_8___default.a.login();
        case 10:
          res = _context.sent;
          _ref2 = res || {}, errCode = _ref2.errCode;
          if (!(errCode === 0)) {
            _context.next = 15;
            break;
          }
          succCallback(res);
          return _context.abrupt("return", res);
        case 15:
          if (!(errCode === 2)) {
            _context.next = 17;
            break;
          }
          return _context.abrupt("return", res);
        case 17:
          failCallback(res);
          return _context.abrupt("return", res);
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function login() {
    return _ref.apply(this, arguments);
  };
}();
var logout = /*#__PURE__*/function () {
  var _ref3 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee2() {
    var _len2,
      args,
      _key2,
      _paramsHandle2,
      succCallback,
      failCallback,
      res,
      _ref4,
      errCode,
      _args2 = arguments;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          for (_len2 = _args2.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = _args2[_key2];
          }
          _paramsHandle2 = Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["paramsHandle"])(args), succCallback = _paramsHandle2.succCallback, failCallback = _paramsHandle2.failCallback;
          _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_8___default.a.isHidePhoneLogin = Object(_config__WEBPACK_IMPORTED_MODULE_11__[/* isHidePhoneLogin */ "a"])();
          _context2.next = 5;
          return _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_8___default.a.logout();
        case 5:
          res = _context2.sent;
          _ref4 = res || {}, errCode = _ref4.errCode;
          if (!(errCode === 0)) {
            _context2.next = 10;
            break;
          }
          succCallback(res);
          return _context2.abrupt("return", res);
        case 10:
          failCallback(res);
          return _context2.abrupt("return", res);
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function logout() {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * 判断用户是否登录
 * 旧方法，同步，直接使用浏览器cookie操作
 */
var isLogin = function isLogin() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  var _paramsHandle3 = Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["paramsHandle"])(args),
    opts = _paramsHandle3.opts,
    succCallback = _paramsHandle3.succCallback;
  var _opts$checkVideo = opts.checkVideo,
    checkVideo = _opts$checkVideo === void 0 ? !Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["isGameMsdk"])() && !Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["isWeishi"])() : _opts$checkVideo;
  var res = (!checkVideo || Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["checkVUserId"])()) && (Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["checkQQ"])() || Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["checkWX"])());
  var rel = !!res;

  // 腾讯视频爱玩业务不支持手机登录，如果是默认不支持手机登录的情况，并且是手机登录，则返回 false
  if (Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["isTenvideo"])() && checkVideo && Object(_config__WEBPACK_IMPORTED_MODULE_11__[/* isHidePhoneLogin */ "a"])() && _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4__["cookie"].get('main_login') === 'phone') {
    succCallback(false);
    return false;
  }
  succCallback(rel);
  return rel;
};

/**
 * 判断用户是否登录
 * 新方法，异步，会使用iwan-login包，调用准确bridge方法有异步判断
 */
var checkLogin = /*#__PURE__*/function () {
  var _ref5 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee3() {
    var _len4,
      args,
      _key4,
      _paramsHandle4,
      succCallback,
      _yield$iwanLogin$isLo,
      isLogin,
      _args3 = arguments;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          for (_len4 = _args3.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = _args3[_key4];
          }
          _paramsHandle4 = Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["paramsHandle"])(args), succCallback = _paramsHandle4.succCallback;
          _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_8___default.a.isHidePhoneLogin = Object(_config__WEBPACK_IMPORTED_MODULE_11__[/* isHidePhoneLogin */ "a"])();
          _context3.next = 5;
          return _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_8___default.a.isLogin();
        case 5:
          _yield$iwanLogin$isLo = _context3.sent;
          isLogin = _yield$iwanLogin$isLo.result;
          succCallback(isLogin);
          return _context3.abrupt("return", isLogin);
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function checkLogin() {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * 切换登录
 */
var changeLogin = function changeLogin() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    inRefresh: false
  };
  return new Promise(function (resolve) {
    if (Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["isSports"])()) {
      _tencent_txv_athena_comps_common_tips__WEBPACK_IMPORTED_MODULE_9___default()({
        text: _tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_5__["NO_CHANGE_LOGIN_TIPS"].sports
      });
      return;
    }
    if (Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["isWeishi"])()) {
      _tencent_txv_athena_comps_common_tips__WEBPACK_IMPORTED_MODULE_9___default()({
        text: _tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_5__["NO_CHANGE_LOGIN_TIPS"].weishi
      });
      return;
    }
    var inRefresh = opts.inRefresh;
    // 视频app内直接拉起登录页切换登录，可切换可取消
    // 未登录 直接拉起登录
    // 微视不在此情况原因：微视已登录时执行登录不会拉起登录界面；登录/注销功能都是静默执行
    checkLogin().then(function (isLogin) {
      if (Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["isTenvideo"])() || !isLogin) {
        login().then(function (res) {
          resolve(res);
          var errCode = res.errCode;
          errCode === 0 && inRefresh && location.reload();
        });
        return;
      }

      // 视频app外有弹层二次提示是否切换
      var dialog = new _tencent_txv_athena_comps_common_dialog__WEBPACK_IMPORTED_MODULE_6___default.a('body', {
        className: 'dialog-logout-confirm dialog-btn-inline',
        body: '是否退出当前账号？'
      });
      var dialogFooter = dialog.$footer;
      var cancelButton = new _tencent_txv_athena_comps_common_button__WEBPACK_IMPORTED_MODULE_7___default.a(dialogFooter, {
        text: '取消'
      });
      var confirmButton = new _tencent_txv_athena_comps_common_button__WEBPACK_IMPORTED_MODULE_7___default.a(dialogFooter, {
        text: '切换账号',
        type: 'primary'
      });
      confirmButton.on('button-click', function () {
        dialog.destroy();
        var retCode;
        logout().then(function () {
          setTimeout(function () {
            login().then(function (res) {
              retCode = res.errCode;
              if (res.errCode === -1) {
                // 登录操作返回的-1，整个切换登录操作新增errCode是3
                resolve(_tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_5__["LOGIN_STATUS"].logoutCancelLogin);
              } else {
                resolve(res);
              }
            })["finally"](function () {
              [0, -1].includes(retCode) && inRefresh && location.reload();
            });
          }, 200);
        })["catch"](function () {
          location.reload();
        });
      });
      cancelButton.on('button-click', function () {
        dialog.destroy();
        resolve(_tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_5__["LOGIN_STATUS"].cancel);
      });
      dialog.on('close', function () {
        resolve(_tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_5__["LOGIN_STATUS"].cancel);
      });
    });
  });
};

/**
 * 获取用户登录相关参数
 * appid,openid,access_token,vuserid,vusession统一名字，这些值在qq情况下是来自vqq_xxx的
 */
var userCookie = /*#__PURE__*/function () {
  var _ref6 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee4() {
    var result, loginInfo, cookieData, _result, type, loginType, userData;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          result = {};
          _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_8___default.a.isHidePhoneLogin = Object(_config__WEBPACK_IMPORTED_MODULE_11__[/* isHidePhoneLogin */ "a"])();
          // 兼容问题处理：iwan-login有对域名严格限制，针对端外h5情况非iwan域名不会从cookie取值。该处理是从当前cookie取值
          _context4.next = 4;
          return _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_8___default.a.getLoginInfo();
        case 4:
          loginInfo = _context4.sent;
          result = _objectSpread(_objectSpread({}, result), loginInfo.result);
          cookieData = {
            appid: _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4__["cookie"].get('vqq_appid') || _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4__["cookie"].get('appid'),
            openid: _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4__["cookie"].get('vqq_openid') || _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4__["cookie"].get('openid'),
            accessToken: _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4__["cookie"].get('vqq_access_token') || _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4__["cookie"].get('access_token')
          };
          result = _objectSpread(_objectSpread({}, cookieData), result);
          _result = result, type = _result.type;
          loginType = Object(_common__WEBPACK_IMPORTED_MODULE_10__[/* handleLoginType */ "a"])(type);
          userData = {};
          if (loginType === 'qq') {
            userData = _objectSpread({
              acctype: 'qq',
              access_token: result.accessToken
            }, result);
            if (result.openid && result.accessToken) {
              userData.token = Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["token"])(result.accessToken.substr(0, 10));
            } else {
              userData.token = Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["token"])(result.skey);
            }
          } else if (loginType === 'wx') {
            userData = _objectSpread(_objectSpread({
              acctype: 'wx',
              access_token: result.accessToken
            }, result), {}, {
              token: Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["token"])(result.accessToken.substr(0, 10))
            });
          }
          return _context4.abrupt("return", userData);
        case 13:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function userCookie() {
    return _ref6.apply(this, arguments);
  };
}();

/**
 * 得到用户标识，给到的是QQ的openid或uin，微信的openid
 */
var userKey = /*#__PURE__*/function () {
  var _ref7 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee5() {
    var _yield$iwanLogin$getL, loginInfo;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_8___default.a.isHidePhoneLogin = Object(_config__WEBPACK_IMPORTED_MODULE_11__[/* isHidePhoneLogin */ "a"])();
          _context5.next = 3;
          return _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_8___default.a.getLoginInfo();
        case 3:
          _yield$iwanLogin$getL = _context5.sent;
          loginInfo = _yield$iwanLogin$getL.result;
          return _context5.abrupt("return", _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4__["cookie"].get('uin') || _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4__["cookie"].get('vqq_openid') || _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4__["cookie"].get('openid') || loginInfo.openid || '');
        case 6:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function userKey() {
    return _ref7.apply(this, arguments);
  };
}();

/**
 * php老接口公共参数获取
 */
var getCommonParams = /*#__PURE__*/function () {
  var _ref8 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee6() {
    var cookieArr, platformId, params, userRes, userToken, acctype;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          cookieArr = ['athena_api_imei', 'athena_api_idfa', 'athena_api_guid'];
          _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4__["cookie"].del(cookieArr);
          platformId = Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["getPlatformId"])();
          /**
           * api接口统一参数platformId
           * platformid兼容礼包领取exchange等后台返回会被限制情况
           */
          params = {
            platformId: platformId,
            platformid: platformId
          };
          if (!(!Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["checkQQ"])() && !Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["checkWX"])())) {
            _context6.next = 6;
            break;
          }
          return _context6.abrupt("return", params);
        case 6:
          _context6.next = 8;
          return userCookie();
        case 8:
          userRes = _context6.sent;
          userToken = userRes.token, acctype = userRes.acctype;
          return _context6.abrupt("return", _objectSpread(_objectSpread({}, params), {}, {
            token: userToken,
            acctype: acctype
          }));
        case 11:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function getCommonParams() {
    return _ref8.apply(this, arguments);
  };
}();

/**
 * 登录后刷新页面
 */
var loginThenReload = function loginThenReload() {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;
  login(function () {
    if (Object(_tencent_txv_athena_helper__WEBPACK_IMPORTED_MODULE_3__["getPhoneSystem"])() === 'ios') {
      var _window$TenvideoJSBri;
      (_window$TenvideoJSBri = window.TenvideoJSBridge) === null || _window$TenvideoJSBri === void 0 || _window$TenvideoJSBri.invoke('reloadWKCookie', null, function (res) {
        var _json$result;
        var json = typeof res === 'string' ? JSON.parse(res) : res;
        if ((json === null || json === void 0 ? void 0 : json.errCode) === 0 && json !== null && json !== void 0 && (_json$result = json.result) !== null && _json$result !== void 0 && _json$result.success) {
          window.location.reload();
          return;
        }
        setTimeout(function () {
          return window.location.reload();
        }, 500);
      });
      return;
    }
    setTimeout(function () {
      return window.location.reload();
    }, timeout);
  });
};

/***/ })
/******/ ]);